export default {
  name: 'marking--taskManagerErrors',
  apiService: 'shoes',
  apiPath: '/admin/task_execution_error',
};